module.exports = __webpack_public_path__ + "img/primeiro_lugar.6ca4d028.png";